var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.discriminant = void 0;
  function discriminant(parsedDiscriminant, rawDiscriminant) {
    return {
      parsedDiscriminant,
      rawDiscriminant
    };
  }
  exports.discriminant = discriminant;
  return exports;
}